module.exports = __webpack_public_path__ + "static/media/trashcan.d36bd4a7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/trashcan.svg
// module id = 365
// module chunks = 1